import React, { useEffect, useState } from 'react';
import ContentfulContext, { ContentfulContextInterface } from './ContentfulContext';
import { useContentfulClient } from '@/lib/contentful/useContentfulClient';

const ContentfulProvider = ({ children }: Props): JSX.Element => {
  const contentfulClient = useContentfulClient();
  const [globalSettings, setGlobalSettings] = useState<any>({});
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const dataIsReady = Object.keys(globalSettings).length > 0;

  useEffect(() => {
    if (!dataIsReady) {
      const fetchGlobalSettings = async () => {
        try {
          const response = await contentfulClient.getEntries({
            include: 2,
            content_type: 'globalSettings',
          });

          setGlobalSettings(response.items[0].fields);
        } catch (err) {
          setError(err);
        } finally {
          setLoading(false);
        }
      };
      fetchGlobalSettings();
    }
  },[dataIsReady]);

  const context: ContentfulContextInterface = {
    globalSettings
  };

  return (
    <ContentfulContext.Provider value={context}>
      {children}
    </ContentfulContext.Provider>
  );
};

export default ContentfulProvider;
